import React from 'react';

import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import type { SxProps, Theme } from '@mui/material/styles';

import { LiquidAddition } from 'client/app/apps/disco-prototype/state/actions/makeMixtureAction';

type Props = {
  items: LiquidAddition[];
  sx?: SxProps<Theme>;
};

const LiquidList: React.FC<Props> = ({ items, sx }) => {
  return (
    <List sx={{ p: 0, ...sx }}>
      {items.map((item, idx) => (
        <React.Fragment key={item.sourceName + idx}>
          <ListItem disableGutters>
            <ListItemText primary={item.sourceName} secondary={item.mode} />
          </ListItem>
          {idx < items.length - 1 && <Divider component="li" />}
        </React.Fragment>
      ))}
    </List>
  );
};

export default LiquidList;
